import api from "./api";

export function getThemeService() {
    return api.get('/themes')
}
